export default "__VITE_ASSET__CUrFw7KY__"